import { render, staticRenderFns } from "./AxStep.vue?vue&type=template&id=df801de2&scoped=true&"
import script from "./AxStep.vue?vue&type=script&lang=js&"
export * from "./AxStep.vue?vue&type=script&lang=js&"
import style0 from "./AxStep.vue?vue&type=style&index=0&id=df801de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df801de2",
  null
  
)

export default component.exports